export function readObject(key: string): object | undefined {
  const val = localStorage.getItem(key)
  if (!val) {
    return undefined
  }

  return JSON.parse(val) as object
}

export function deserializeBool(saved: string): boolean {
  return saved === 'true'
}

export function readBool(key: string): boolean | undefined {
  const saved = localStorage.getItem(key)
  if (saved == undefined) {
    return undefined
  }
  return deserializeBool(saved)
}

export function serializeBool(value: boolean): string {
  return value ? 'true' : 'false'
}

export function writeBool(key: string, value: boolean): void {
  localStorage.setItem(key, serializeBool(value))
}

export function readNumber(key: string): number | undefined {
  const saved = localStorage.getItem(key)
  if (saved == undefined) {
    return undefined
  }
  const parsed = Number(saved)
  return isNaN(parsed) ? undefined : parsed
}

export function writeNumber(key: string, value: number): void {
  localStorage.setItem(key, value.toString())
}
